import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Navigate } from "react-router-dom";
import { API } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    if (localStorage.getItem("admin_token")) {
        return <Navigate to="/admin" replace />;
    }

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const r = await axios.post(`${API}/admin/login`, { email, password });
            localStorage.setItem("admin_token", r.data.token);
            localStorage.setItem("admin_email", r.data.email);
            toast.success("Signed in");
            navigate("/admin");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-background px-6">
            <div className="w-full max-w-md">
                <p className="overline">Studio Admin</p>
                <h1 className="mt-4 font-display text-4xl font-medium tracking-tight">
                    Sign in
                </h1>
                <p className="mt-2 text-foreground/60 text-sm">
                    Manage portfolio projects, enquiries and analytics.
                </p>
                <form
                    onSubmit={submit}
                    data-testid="admin-login-form"
                    className="mt-10 space-y-2"
                >
                    <div className="pt-6 pb-2">
                        <label className="overline block mb-1">Email</label>
                        <input
                            required
                            type="email"
                            data-testid="admin-login-email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="field-line"
                            autoComplete="email"
                        />
                    </div>
                    <div className="pt-6 pb-2">
                        <label className="overline block mb-1">Password</label>
                        <input
                            required
                            type="password"
                            data-testid="admin-login-password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="field-line"
                            autoComplete="current-password"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="admin-login-submit"
                        className="btn-primary mt-8 w-full"
                    >
                        {loading && <Loader2 size={14} className="animate-spin" />}
                        {loading ? "Signing in…" : "Sign in"}
                    </button>
                </form>
                <a
                    href="/"
                    className="mt-10 block text-[12px] tracking-[0.15em] uppercase text-foreground/50 hover:text-foreground transition-colors"
                >
                    ← Back to site
                </a>
            </div>
        </div>
    );
}
